import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { txt } from 'libs/i18n';
import AddItemButton from 'components/SelectWithActions/AddItemButton';
import { SpeakerTreeItem } from './SpeakerTreeItem';
import styles from './style.module.less';
export const SpeakerTreePanel = ({ tree, width, allowButtonActions, onAction, onToggleExpand, }) => {
    const panelRef = useRef(null);
    useEffect(() => {
        var _a;
        const focusedEl = (_a = panelRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('[data-focused="true"]');
        focusedEl === null || focusedEl === void 0 ? void 0 : focusedEl.scrollIntoView({ block: 'nearest' });
    }, [tree.focus]);
    return (_jsxs("div", { ref: panelRef, className: styles.panel, style: { width }, children: [tree.nodes.map((node, speakerIndex) => {
                const isFocused = tree.focus.kind === 'speaker'
                    && tree.focus.speakerIndex === speakerIndex;
                let focusedRoleIndex = null;
                if (tree.focus.kind === 'role' && tree.focus.speakerIndex === speakerIndex) {
                    focusedRoleIndex = tree.focus.roleIndex;
                }
                else if (tree.focus.kind === 'noRole' && tree.focus.speakerIndex === speakerIndex) {
                    // "no role" focus is encoded as the index one past the last role
                    focusedRoleIndex = node.rolesCount;
                }
                return (_jsx(SpeakerTreeItem, { node: node, isFocused: isFocused, focusedRoleIndex: focusedRoleIndex, focusedAddRole: tree.focus.kind === 'addRole' && tree.focus.speakerIndex === speakerIndex, focusedEditSpeaker: tree.focus.kind === 'editSpeaker' && tree.focus.speakerIndex === speakerIndex, allowButtonActions: allowButtonActions, onSelect: (selection) => onAction({ kind: 'selectSpeaker', selection }), onToggleExpand: () => onToggleExpand(speakerIndex), onAddRole: () => {
                        var _a;
                        return onAction({
                            kind: 'addRole',
                            speakerId: (_a = node.speaker.dbid) !== null && _a !== void 0 ? _a : node.speaker.id,
                            firstName: node.speaker.firstName,
                            lastName: node.speaker.lastName,
                        });
                    }, onEditSpeaker: () => onAction({
                        kind: 'editSpeaker',
                        speakerId: node.speaker.id,
                        firstName: node.speaker.firstName,
                        lastName: node.speaker.lastName,
                    }) }, node.speaker.id));
            }), allowButtonActions && (_jsx("div", { className: styles.addSpeakerRow, children: _jsx(AddItemButton, { active: tree.focus.kind === 'addSpeaker', label: txt('addSpeaker'), onClick: () => onAction({ kind: 'addSpeaker' }) }) }))] }));
};
